import { Box, Typography } from "@mui/material";
import { useTranslationSetup } from "../../utils/useTranslationSetup";
import girlStanding from "../../assets/girl-standing.svg";
import { useEffect } from "react";
import "./styles.css";

const ThankYouScreen = ({ onRedirect }) => {
  const { t } = useTranslationSetup();

  useEffect(() => {
    const timer = setTimeout(() => {
      onRedirect();
    }, 3000);

    return () => clearTimeout(timer);
  }, [onRedirect]);

  return (
    <Box className="thank-you-container">
      <Box className="thank-you-content">
        <img
          src={girlStanding}
          alt="girl-standing-img"
          className="thank-you-image"
        />
        <Box className="heading-and-text">
          <Typography className="thank-you-heading">
            {t("thank_you")}
          </Typography>
          <Typography className="thank-you-text">
            {t("thank_you_desc")}
          </Typography>
        </Box>
      </Box>
      <Box className="thank-you-bottom-text-wrapper">
        <Typography className="hold-on-text">{t("hold_on")}</Typography>
        <Typography className="thank-you-bottom-text">
          {t("please_wait_desc")}
        </Typography>
      </Box>
    </Box>
  );
};

export default ThankYouScreen;
